module.exports = __webpack_public_path__ + "static/media/email.24b24016.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contacts/email.svg
// module id = 364
// module chunks = 0